import { DataAttributeDefinitions } from 'scrivito'

import { pisaAddressContactRelationDataClass } from './Pisa/pisaAddressContactRelationDataClass'

const attributes: DataAttributeDefinitions = {}

export const AddressContactRelation =
  pisaAddressContactRelationDataClass(attributes)
